import React from "react";

export const Loading = (  ) => <div className="animated fadeIn pt-3 text-center">Loading...</div>;